export const Colors = {
  common: {
    black: 'black',
    white: 'white',
    primary: 'blue'
  },
};
